import React, { Suspense, useCallback } from 'react';
import useContext from '../hooks/useContext';
import { SiteContext } from '../SiteContext';
import { PreviewContext } from './PreviewProvider';

interface IDatePickerProps {
  date?: Date;
  onChange: (dateString: string, date: Date) => void;
}
type DatePicker = React.LazyExoticComponent<({ date }: IDatePickerProps) => JSX.Element>;

const PreviewDateTimePicker = React.lazy(
  () => import('../components-legacy/PreviewDateTimePicker'),
) as unknown as DatePicker;

const Preview = () => {
  const { date, setDate } = useContext(PreviewContext) || {};
  const {
    data: { isPreview },
  } = useContext(SiteContext);

  const change = useCallback((_: string, date: Date) => {
    setDate(date);
  }, []);

  if (!isPreview || SSR) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <PreviewDateTimePicker date={date} onChange={change} />
    </Suspense>
  );
};

export default Preview;
